import { usePersistedState } from './use-persisted-state';

export { usePersistedState };
export default usePersistedState;
